import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Text from 'components/Text';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function formatMessage() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(message)
  // multiple line-breaks will be reduced to a single line gap
  .replace(/\n\n\n+/g, '\n\n')
  // leading and trailing white-space will be removed
  .trim();
}
var CommentBodyContent = styled.span.withConfig({
  displayName: "CommentBody__CommentBodyContent",
  componentId: "sc-cyvwd4-0"
})(["white-space:pre-line;white-space:break-spaces;"]);
export function CommentBody(_ref) {
  var isDeleted = _ref.isDeleted,
    authorName = _ref.authorName,
    message = _ref.message;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var formattedMessage = useMemo(function () {
    return formatMessage(message);
  }, [message]);
  if (isDeleted) {
    return /*#__PURE__*/_jsxs("p", {
      children: [t('deleted_comment_content'), " "]
    });
  }
  return /*#__PURE__*/_jsxs(CommentBodyContent, {
    children: [/*#__PURE__*/_jsx(Text, {
      bold: true,
      "aria-hidden": "true",
      children: authorName
    }), ' ', formattedMessage]
  });
}
export default CommentBody;